// extracted by mini-css-extract-plugin
export default {"modalFooterButtons":"ShippingFormWeightEditionModal_modalFooterButtons__abXNp"};